import moment from "moment-timezone";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  IoIosAddCircle,
  IoIosRemoveCircle,
  IoIosCalculator,
  IoMdDoneAll,
} from "react-icons/io";
import {
  BiRupee,
  BiDownArrowAlt,
  BiLocationPlus,
  BiFlag,
  BiPaperclip,
  BiRightArrowAlt,
  BiCommentDetail,
} from "react-icons/bi";
import { MdLibraryAdd, MdVerifiedUser } from "react-icons/md";
import { TiThList } from "react-icons/ti";
import { HiViewGridAdd } from "react-icons/hi";
import { CgAttachment } from "react-icons/cg";
import {
  RiShareForwardFill,
  RiArrowGoBackFill,
  RiUserShared2Line,
  RiUserReceivedLine,
  RiUser3Line,
  RiEditBoxFill,
  RiPrinterFill,
  RiFileExcel2Fill,
  RiSendPlaneFill,
  RiCheckboxMultipleBlankFill,
  RiUpload2Fill,
  RiCloseFill,
} from "react-icons/ri";
import {
  FaFilePdf,
  FaRegCopy,
  FaEdit,
  FaCalendarAlt,
  FaTrashAlt,
  FaSignOutAlt,
  FaBars,
  FaBookReader,
  FaUserEdit,
  FaUserCheck,
} from "react-icons/fa";
import {
  ImFirst,
  ImLast,
  ImHome3,
  ImArrowLeft,
  ImBoxAdd,
} from "react-icons/im";
import { BsEyeFill } from "react-icons/bs";
import { FiPercent, FiAlignJustify } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { GrNotes, GrFormView } from "react-icons/gr";
import { FcProcess, FcApproval, FcFlowChart } from "react-icons/fc";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineExpandAlt } from "react-icons/ai";
import "jspdf-autotable";
import jsPDF from "jspdf";
import MasterService from "../../Services/MasterService";
// import * as XLSX from "sheetjs-style";
import * as XLSX from 'xlsx';

import Select from "react-select";
import { saveAs } from "file-saver";
import domtoimage from "dom-to-image-more";
export const PRINT_ICON = (props) => <RiPrinterFill {...props} />;
export const BACK_ICON = (props) => <ImArrowLeft {...props} />;
export const FW_ICON = (props) => <RiShareForwardFill {...props} />;
export const RETURN_ICON = (props) => <RiArrowGoBackFill {...props} />;
export const APR_ICON = (props) => <IoMdDoneAll {...props} />;
export const COPY_ICON = (props) => <FaRegCopy {...props} />;
export const RUPEE_ICON = (props) => <BiRupee {...props} />;
export const VIEW_ICON = (props) => <BsEyeFill {...props} />;
export const ADDL_ICON = (props) => <MdLibraryAdd {...props} />;
export const BARS_ICON = (props) => <FaBars {...props} />;
export const HOME_ICON = (props) => <ImHome3 {...props} />;
export const CREATE_ICON = (props) => <HiViewGridAdd {...props} />;
export const DRAFT_ICON = (props) => <FaEdit {...props} />;
export const INBOX_ICON = (props) => <ImBoxAdd {...props} />;
export const OUTBOX_ICON = (props) => <FaSignOutAlt {...props} />;
export const LIST_ICON = (props) => <TiThList {...props} />;
export const SEND_ICON = (props) => <RiSendPlaneFill {...props} />;
export const EXECEL_ICON = (props) => <RiFileExcel2Fill {...props} />;
export const PDF_ICON = (props) => <FaFilePdf {...props} />;
export const FIRST_ICON = (props) => <ImFirst {...props} />;
export const LAST_ICON = (props) => <ImLast {...props} />;
export const EDIT_ICON = (props) => <RiEditBoxFill {...props} />;
export const ADD_ICON = (props) => <IoIosAddCircle {...props} />;
export const REMOVE_ICON = (props) => <IoIosRemoveCircle {...props} />;
export const ATTACH_ICON = (props) => <CgAttachment {...props} />;
export const LOCATION_ICON = (props) => <BiLocationPlus {...props} />;
export const FLAG_ICON = (props) => <BiFlag {...props} />;
export const PAPERCLIP_ICON = (props) => <BiPaperclip {...props} />;
export const CAL_ICON = (props) => <IoIosCalculator {...props} />;
export const COMMENT_ICON = (props) => <BiCommentDetail {...props} />;
export const MODAL_ICON = (props) => <RiCheckboxMultipleBlankFill {...props} />;
export const UPLOAD_ICON = (props) => <RiUpload2Fill {...props} />;
export const CALENDAR_ICON = (props) => <FaCalendarAlt {...props} />;
export const PERCENTAGE_ICON = (props) => <FiPercent {...props} />;
export const NOTES_ICON = (props) => <GrNotes {...props} />;
export const COLLAPSE_ICON = (props) => <BiRightArrowAlt {...props} />;
export const EXPAND_ICON = (props) => <BiDownArrowAlt {...props} />;

export const PROCESS_ICON = (props) => <FcProcess {...props} />;
export const APPROVED_ICON = (props) => <FcApproval {...props} />;
export const RETURNED_ICON = (props) => <GiReturnArrow {...props} />;

export const CLOSE_ICON = (props) => <RiCloseFill {...props} />;
export const MENU_ICON = (props) => <FiAlignJustify {...props} />;
export const MBOOK_ICON = (props) => <FaBookReader {...props} />;
export const SHOW_ICON = (props) => <GrFormView {...props} />;

export const DOC_FLOW_ICON = (props) => <FcFlowChart {...props} />;

export const S_MAKER_ICON = (props) => <FaUserEdit {...props} />;
export const S_FWD_ICON = (props) => (
  <RiUserShared2Line color="#0fa549" {...props} />
);
export const S_CHECKER_ICON = (props) => <FaUserCheck {...props} />;
export const S_RETURN_ICON = (props) => (
  <>
    <RiUserReceivedLine color="red" {...props} />
  </>
);
export const S_FINISH_ICON = (props) => (
  <MdVerifiedUser color="#0fa549" {...props} />
);
export const S_PENDING_ICON = (props) => (
  <RiUser3Line color="#bfbdbd" {...props} />
);
export const EXPANDTABLE_ICON = (props) => <AiOutlineExpandAlt {...props} />;
export const STEP_ICON = (props) => <GiReturnArrow {...props} />;

export const DELETE_ICON = (props) => <FaTrashAlt {...props} />;

export const DOC_FLOW_LINK = (props) => (
  <Link
    className="btn btn-sm btn-primary"
    role="button"
    to={{
      pathname: "/newDocFlow",
      state: {
        workType: props?.workType,
        subWorkType: props?.subWorkType,
        workId: props?.workId,
      },
    }}
    data-tip="Document Flow"
  >
    {" "}
    <DOC_FLOW_ICON /> Doc Flow{" "}
  </Link>
);

export const BACK_LINK = (props) => {
  const { history, onClick } = props;
  return (
    history?.length > 0 && (
      <Button
        size="sm"
        data-tip="Go Back"
        variant="primary"
        onClick={(event) => {
          onClick && onClick(event);
          if (history.length > 1) {
            history.goBack();
          } else {
            history.push("/home");
          }
        }}
      >
        {" "}
        <BACK_ICON /> BACK{" "}
      </Button>
    )
  );
};

export const showNotification = (type, message) => {
  if (type === "success") {
    Swal.fire("Success", message, "success");
  } else if (type === "error") {
    Swal.fire("Error", message, "error");
  } else if (type === "warning") {
    Swal.fire("Warning", message, "warning");
  } else if (type === "info") {
    Swal.fire("info", message, "info");
  }
};

export function roundAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount);
}

export function roundOfZeroAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(0);
  return parseFloat(amount);
}

export function amountFormat(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function amountQuantity(value) {
  let amount = (parseFloat(value) || 0).toFixed(4);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function dateFormat(date) {
  return date ? moment(date).format("DD-MMM-YYYY  hh:mm A") : "-";
}

export function dateFormatWithoutTime(date) {
  return date ? moment(date).format("DD-MM-YYYY") : "-";
}

export function roundQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(5);
  return parseFloat(qty);
}

export function roundEpcQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(10);
  return parseFloat(qty);
}

export function isValidNumber(value) {
  if (value !== "") {
    const pattern = /^(0|[1-9]\d*)$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export const NAME_OF_WORK_LENGTH = 50;

export const remaininCharacters = (count, value) => {
  return <>(Remaining Characters : {count - (value?.length || 0)})</>;
};

export const DETAILS_OF_WORK_LENGTH = 500;
export const DETAILS_OF_WORK_LENGTH2 = 100;

export function OnlyNumbers(value) {
  if (value !== "") {
    var pattern = /^[1-9]\d*(\.\d+(?:\.\d{1,2}))?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidFloat(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,7})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidRate(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,2})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidEpcQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,10})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export const NumberValidation = (e) => {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumber(value);
  } else {
    e.preventDefault();
  }
  return false;
};

export const allowAlphabetAndSpacesOnly = (e) => {
  var keyCode = e.charCode;
  var value = Number(e.target.value + e.key) || 0;
  if (
    !(keyCode >= 65 && keyCode <= 123) &&
    keyCode !== 32 &&
    keyCode !== 0 &&
    keyCode !== 40 &&
    keyCode !== 41
  ) {
    e.preventDefault();
  } else {
    return value;
  }
  return false;
};

export function isValidPaidQty(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function PickerFormat(date) {
  return date ? moment(date).format("DD-MM-yyyy") : "";
}
export const AMOUNT_LENGTH = 12;

export const VALID_TO = moment("31-12-9999", "DD-MM-YYYY").toDate();

export const ADD_YEARS_VALID_TO = (date) => {
  return moment(date).add(5, "years").toDate();
};

export function groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export const AGREEMENTAMOUNT = 18;

export function FireConfirmationSwal(msg) {
  Swal.fire({
    icon: "question",
    title: "",
    text: msg,
    confirmButtonText: "OK",
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  });
  return false;
}

export const SumAmount = (array, keyName) => {
  return array.reduce((sum, row) => parseFloat(row[keyName]) + sum, 0);
};

export const NotesRemaininCharacters = (value) => {
  return <>({500 - (value || 0)})</>;
};

export function convertStringToDate(date) {
  return moment(date, "DD-MM-YYYY");
}

export const COLOUR_STATUS = (props) => {
  let obj = { S01: "#ffbf00", S02: "#4fa0b9", S03: "#6fa000", S04: "#ff4c00" };
  return (
    <>
      {" "}
      <p style={{ color: obj[props?.statusCode], fontSize: "20px" }}>
        {" "}
        <b>{props?.statusDesc}</b>{" "}
      </p>{" "}
    </>
  );
};

export default function allowNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumbers(value);
  } else {
    e.preventDefault();
  }
  return false;
}

const isValidNumbers = (number) => {
  return 1 <= number && number <= 10;
};

export function ClearLocalStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("serviceList");
  localStorage.clear();
}

export function istwodecimals(e) {
  if (
    e.key !== "Backspace" &&
    e.key !== "Delete" &&
    e.key !== "." &&
    e.key !== "-" &&
    (isNaN(Number(e.key)) ||
      (e.target.value.includes(".") &&
        e.target.value.split(".")[1].length >= 2))
  ) {
    e.preventDefault();
  }
}

export function isValid(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

// export function isValidsix(e) {
//   const inputValue = e.target.value;
//   if (
//     (e.key !== "Backspace" &&
//       e.key !== "Delete" &&
//       e.key !== "-" &&
//       e.key !== "." &&
//       (isNaN(Number(e.key)) ||
//         (inputValue.includes(".") && inputValue.split(".")[1].length >= 6))) ||
//     (e.key === "." && inputValue.includes("."))
//   ) {
//     e.preventDefault();
//   }
// }

export function isValidsix(e) {
  const inputValue = e.target.value;

  if (
    (e.key === "." && inputValue.length === 0) ||

    (
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") &&
          inputValue.split(".")[1].length >= 6))
    ) ||

    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export function generatePdf(tableid, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  console.log("columnsCount", columnsCount);

  let format = "a4";
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  doc.autoTable({
    html: tableid,
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { halign: "center" },
    columnStyles: {
      0: { cellWidth: "wrap" },
    },
    didParseCell: function (data) {const rawText = data.cell.text?.join(" ")?.trim();

      if (rawText?.startsWith("Report On")) { data.cell.styles.halign = "right"; }

      if (data.cell.raw && data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; }
    },
  });
  doc.save(`${filename}.pdf`); exportHeaders.forEach((el) => { el.style.display = "none"; });
}

export function generatelargePdf(tableid, filename) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [3000, 3000],
  });

  doc.autoTable({
    html: tableid,
    theme: "grid",
    tableWidth: "wrap",
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) { const rawText = data.cell.text?.join(" ")?.trim(); if (rawText?.startsWith("Report On")) { data.cell.styles.halign = "right"; }

      if (data.cell.raw && data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; } }, }); doc.save(`${filename}.pdf`);
  exportHeaders.forEach((el) => { el.style.display = "none"; }); }

export function generateindicatorpdf(filteredData1) {
  if (!Array.isArray(filteredData1) || filteredData1.length === 0) {
    return;
  }

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  doc.setFontSize(12);
  doc.text("Mapped Indicators (or) Activity", 14, 15);
  const tableHead = [
    { content: "Slno.", styles: { halign: "center", fontStyle: "bold" } },
    {
      content: "Sub Indicator Name",
      styles: { halign: "center", fontStyle: "bold" },
    },
    { content: "Unit", styles: { halign: "center", fontStyle: "bold" } },
  ];
  const tableBody = [];
  let indexCounter = 1;

  filteredData1.forEach((detail) => {
    if (detail.indicator_name) {
      tableBody.push([
        {
          content: detail.indicator_name,
          colSpan: 3,
          styles: { halign: "center", fontStyle: "bold" },
        },
      ]);
    }

    if (detail.sub_indicator_name) {
      tableBody.push([
        { content: indexCounter, styles: { halign: "center" } },
        { content: detail.sub_indicator_name, styles: { halign: "left" } },
        { content: detail.unit || "", styles: { halign: "center" } },
      ]);
      indexCounter++;
    }
  });

  doc.autoTable({
    head: [tableHead],
    body: tableBody,
    theme: "grid",
    styles: { fontSize: 8 },
    columnStyles: {
      0: { cellWidth: 15 },
      1: { cellWidth: 100 },
      2: { cellWidth: 50 },
    },
    startY: 20,
  });

  doc.save("Mandal Mapping.pdf");
}

export function exportToExcelindicator(filteredData1) {
  if (!Array.isArray(filteredData1)) {
    return;
  }

  const wsData = filteredData1.map((detail, i) => [
    detail.indicator_name || "",
    detail.sub_indicator_name || "",
    detail.unit || "",
  ]);

  const headers = ["Indicator Name", "Sub Indicator", "Unit"];
  wsData.unshift(headers);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  XLSX.writeFile(wb, "Mandal Mapping.xlsx");
}

export function exportToExcel(tableId, fileName) {
  const table = document.getElementById(tableId); if (!table) { console.error(`Table with ID ${tableId} not found!`); return; }

  try {
    const sheetName = fileName.length > 31 ? fileName.substring(0, 31) : fileName; const rows = []; const merges = []; const occupied = {}; const maxTextLengths = [];

    const tableRows = Array.from(table.rows);

    tableRows.forEach((row, rowIndex) => { const rowData = []; let colIndex = 0; while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }

      Array.from(row.cells).forEach((cell) => {const colspan = parseInt(cell.getAttribute("colspan")) || 1; const rowspan = parseInt(cell.getAttribute("rowspan")) || 1; const cellValue = cell.textContent.trim(); const isHeader = row.parentElement.tagName === "THEAD";

        let horizontalAlign = isHeader ? "center" : "left"; if (row.textContent.includes("Report On")) { horizontalAlign = "right"; }
        const alignment = { horizontal: horizontalAlign, vertical: "center", wrapText: true, }; const cellStyle = { alignment, font: { bold: isHeader, color: { rgb: "000000" } }, };

        rowData[colIndex] = { v: cellValue, s: cellStyle };

        if (colspan === 1) { const estimatedWidth = cellValue.length <= 4 ? cellValue.length + 4 : Math.ceil(cellValue.length * 1.2); maxTextLengths[colIndex] = Math.max( maxTextLengths[colIndex] || 0, estimatedWidth, ); }

        if (colspan > 1 || rowspan > 1) { merges.push({ s: { r: rowIndex, c: colIndex }, e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, });

          for (let r = 0; r < rowspan; r++) { for (let c = 0; c < colspan; c++) { if (r !== 0 || c !== 0) { occupied[`${rowIndex + r},${colIndex + c}`] = true; } } }
        }

        colIndex += colspan; while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; } }); rows.push(rowData); });

    const ws = XLSX.utils.aoa_to_sheet(rows); ws["!merges"] = merges; ws["!cols"] = maxTextLengths.map((wch) => ({ wch })); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) { console.error("Error exporting to Excel:", error); }
}

export function exportToExcelhidelastcol(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;

    const rows = Array.from(table.rows).map((row) => {
      return Array.from(row.cells)
        .slice(0, -1)
        .map((cell) => {
          const icon = cell.querySelector("img, svg, i");
          if (icon && icon.alt) {
            return icon.alt;
          }
          return cell.textContent.trim();
        });
    });

    const ws = XLSX.utils.aoa_to_sheet(rows);

    const range = XLSX.utils.decode_range(ws["!ref"]);
    ws["!ref"] = XLSX.utils.encode_range(range);

    const columnWidths = [];
    for (let col = 0; col <= range.e.c; col++) { const colLetter = XLSX.utils.encode_col(col); const cellWidth = Math.max( ...Object.keys(ws) .filter((cell) => cell.startsWith(colLetter)) .map((cell) => ws[cell] ? (ws[cell].v ? ws[cell].v.toString().length : 0) : 0, ), ); columnWidths[col] = { wch: cellWidth + 2 }; }
    ws["!cols"] = columnWidths;

    const headerRow = range.s.r;
    for (let col = 0; col <= range.e.c; col++) { const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c: col })]; if (cell) { cell.s = { alignment: { horizontal: "center" }, font: { bold: true } }; } }
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`); } catch (error) { console.error("Error exporting to Excel:", error); }
}

export const handleKeyDown = (e) => {
  if (e.key === "Enter" || e.key === "Escape") {
    e.preventDefault();
    e.stopPropagation();
  }
};
export function generatePdfhidelastcol(tableid, filename) {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  doc.autoTable({ html: tableid, theme: "grid", tableWidth: 530, columnStyles: { 3: { cellWidth: "wrap" } }, styles: { fontSize: 10 }, headStyles: { halign: "center" }, didParseCell: function (data) { const columnIndex = data.column.index; const lastColumnIndex = data.table.columns.length - 1; if (columnIndex === lastColumnIndex) { data.cell.raw = null; data.cell.text = ""; data.row.cells[columnIndex] = null; } }, didDrawCell: function (data) { const columnIndex = data.column.index; const lastColumnIndex = data.table.columns.length - 1; if (columnIndex === lastColumnIndex) { data.cell.text = ""; } }, });

  doc.save(`${filename}.pdf`);
}
export function isValidtwo(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export function percentcal(e) {
  const inputValue = e.target.value;

  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
    return;
  }

  const { selectionStart, selectionEnd } = e.target;
  const newValue =
    inputValue.slice(0, selectionStart) +
    e.key +
    inputValue.slice(selectionEnd);

  const numericValue = Number(newValue);
  if (!isNaN(numericValue) && numericValue > 100) {
    e.preventDefault();
  }
}
export function isValidthreee(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 3))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export const generatehodentryPdf = (tableId, formikValues, filename) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [3000, 3000],
  });

  doc.autoTable({
    html: `#${tableId}`,
    theme: "grid",
    tableWidth: "wrap",
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      if (!data.cell.raw) return;
      if (data.cell.raw.querySelector("img")) {
        const img = data.cell.raw.querySelector("img");
        data.cell.text =
          img.getAttribute("alt") || img.getAttribute("data-value") || "Image";
      }
      const fieldInputs = data.cell.raw.querySelectorAll("input, select");
      if (fieldInputs.length > 0) {
        let cellValue = [];
        fieldInputs.forEach((field) => {
          const fieldName = field.getAttribute("name");
          if (fieldName) {
            const formikValue = formikValues[fieldName] || field.value || "";
            cellValue.push(formikValue);
          }
        });
        data.cell.text = cellValue.join(" / ");
      }
    },
  });
  doc.save(`${filename}.pdf`);
};

export const currentDate = new Date().toISOString().split("T")[0];

export const generateentryPdf = (tableId, formikValues, filename) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  doc.autoTable({
    html: `#${tableId}`,
    theme: "grid",
    tableWidth: 530,
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      if (!data.cell.raw) return;
      if (data.cell.raw.querySelector("img")) {
        const img = data.cell.raw.querySelector("img");
        data.cell.text =
          img.getAttribute("alt") || img.getAttribute("data-value") || "Image";
      }
      const fieldInputs = data.cell.raw.querySelectorAll("input, select");
      if (fieldInputs.length > 0) {
        let cellValue = [];
        fieldInputs.forEach((field) => {
          const fieldName = field.getAttribute("name");
          if (fieldName) {
            const formikValue = formikValues[fieldName] || field.value || "";
            cellValue.push(formikValue);
          }
        });
        data.cell.text = cellValue.join(" / ");
      }
    },
  });
  doc.save(`${filename}.pdf`);
};

export const exportToentryExcel = (tableId, formikValues, fileName) => {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error("Table not found!");
    return;
  }

  let data = [];
  let headers = [];
  let headerMatrix = [];
  let mergedHeaders = [];
  const merges = [];
  const maxTextLengths = [];
  const headerRows = table.querySelectorAll("thead tr");
  headerRows.forEach((row, rowIndex) => {
    let rowHeaders = [];
    let colIndex = 0;

    row.querySelectorAll("th").forEach((th) => {
      while (headerMatrix[rowIndex]?.[colIndex]) colIndex++;

      const colspan = parseInt(th.getAttribute("colspan") || "1", 10);
      const rowspan = parseInt(th.getAttribute("rowspan") || "1", 10);
      const text = th.innerText.trim();
      for (let i = 0; i < colspan; i++) {
        const len = text.length;
        maxTextLengths[colIndex + i] = Math.max(
          maxTextLengths[colIndex + i] || 0,
          len,
        );
      }

      rowHeaders[colIndex] = text;
      if (colspan > 1 || rowspan > 1) {
        merges.push({
          s: { r: rowIndex, c: colIndex },
          e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 },
        });
      }

      for (let r = 0; r < rowspan; r++) {
        if (!headerMatrix[rowIndex + r]) headerMatrix[rowIndex + r] = [];
        for (let c = 0; c < colspan; c++) {
          headerMatrix[rowIndex + r][colIndex + c] = text;
        }
      }

      colIndex += colspan;
    });

    headerMatrix[rowIndex] = rowHeaders;
  });

  headerMatrix.forEach((row, rowIndex) => {
    if (rowIndex === 0) {
      mergedHeaders.push(row);
    } else {
      const prev = mergedHeaders[mergedHeaders.length - 1];
      const newRow = row.map((val, idx) => (val === prev[idx] ? "" : val));
      mergedHeaders.push(newRow);
    }
  });

  headers = mergedHeaders;

  const rows = table.querySelectorAll("tbody tr");
  rows.forEach((row) => {
    const rowData = [];
    row.querySelectorAll("td").forEach((cell, index) => {
      const inputs = cell.querySelectorAll("input, select");
      let value = "";

      if (inputs.length > 0) {
        value = Array.from(inputs)
          .map((input) => {
            const name = input.getAttribute("name");
            return formikValues[name] || input.value || "";
          })
          .join(" / ");
      } else {
        value = cell.innerText.trim();
      }

      rowData.push(value);

      const len = value.length;
      maxTextLengths[index] = Math.max(maxTextLengths[index] || 0, len);
    });

    data.push(rowData);
  });

  const allData = [...headers, ...data];
  const worksheet = XLSX.utils.aoa_to_sheet(allData);

  worksheet["!merges"] = merges;

  worksheet["!cols"] = maxTextLengths.map((len) => ({ wch: len + 2 }));

  Object.keys(worksheet).forEach((key) => {
    if (key[0] === "!") return;

    const cell = worksheet[key];
    cell.s = {
      alignment: { vertical: "center", horizontal: "center", wrapText: true },
      font: { bold: headers.some((row) => row.includes(cell.v)) },
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const exportTokpientryExcel = (tableId, formikValues, fileName) => {
  const table = document.getElementById(tableId);
  if (!table) return;

  const merges = [];
  const styles = {};

  const buildMatrixFromTable = (table, formikValues) => {
    const rows = table.querySelectorAll("tr");
    const matrix = [];
    const skipMap = {};

    rows.forEach((row, rowIndex) => {
      let colIndex = 0;
      if (!matrix[rowIndex]) matrix[rowIndex] = [];
      row.querySelectorAll("th, td").forEach((cell) => {
        while (skipMap[`${rowIndex},${colIndex}`]) colIndex++;

        const rowspan = parseInt(cell.getAttribute("rowspan") || "1", 10);
        const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
        const isHeader = cell.tagName.toLowerCase() === "th";

        let value = "";
        const inputs = cell.querySelectorAll("input, select");

        if (inputs.length > 0) {
          value = Array.from(inputs)
            .map((input) => {
              const name = input.getAttribute("name");
              return formikValues[name] || input.value || "";
            })
            .join(" / ");
        } else {
          value = cell.innerText.trim();
        }

        matrix[rowIndex][colIndex] = value;

        if (isHeader) {
          styles[`${rowIndex},${colIndex}`] = {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }

        if (value === "Not Yet Started") {
          styles[`${rowIndex},${colIndex}`] = {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }

        if (rowspan > 1 || colspan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 },
          });

          for (let r = 0; r < rowspan; r++) {
            for (let c = 0; c < colspan; c++) {
              if (r !== 0 || c !== 0) {
                skipMap[`${rowIndex + r},${colIndex + c}`] = true;
                if (!matrix[rowIndex + r]) matrix[rowIndex + r] = [];
                matrix[rowIndex + r][colIndex + c] = "";
              }
            }
          }
        }

        colIndex += colspan;
      });
    });

    return matrix;
  };

  const data = buildMatrixFromTable(table, formikValues);
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  worksheet["!merges"] = merges;

  worksheet["!cols"] = Array(data[0]?.length || 10).fill({ wch: 25 });

  Object.entries(styles).forEach(([key, style]) => {
    const [r, c] = key.split(",").map(Number);
    const cellRef = XLSX.utils.encode_cell({ r, c });
    if (!worksheet[cellRef]) worksheet[cellRef] = { t: "s", v: "" };
    worksheet[cellRef].s = style;
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Entry Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}.xlsx`);
};

export function gsdpReportexcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;
    const rows = [];
    const rowSpans = new Map();
    const merges = [];
    let headerRowCount = 0;

    Array.from(table.rows).forEach((row, rowIndex) => {
      const rowData = [];
      let colIndex = 0;

      if (row.parentElement.tagName.toLowerCase() === "thead") {
        headerRowCount++;
      }

      Array.from(row.cells).forEach((cell) => {
        while (rowSpans.has(`${rowIndex}-${colIndex}`)) {
          rowData.push("");
          colIndex++;
        }

        const text = cell.textContent.trim();
        rowData.push(text);

        if (cell.rowSpan > 1) {
          for (let i = 1; i < cell.rowSpan; i++) {
            rowSpans.set(`${rowIndex + i}-${colIndex}`, text); // Store for future rows
          }
        }

        // Handle colSpan (Merge horizontally)
        if (cell.colSpan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: { r: rowIndex, c: colIndex + cell.colSpan - 1 },
          });

          for (let i = 1; i < cell.colSpan; i++) {
            rowData.push(""); // Fill merged columns with empty string
          }
        }

        colIndex++;
      });

      rows.push(rowData);
    });

    // Convert to Excel format
    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!merges"] = merges; // Apply merged cell configurations

    // Auto-adjust column widths
    ws["!cols"] = rows[0].map((_, colIndex) => ({
      wch:
        Math.max(
          ...rows.map((row) => (row[colIndex] ? row[colIndex].length : 0)),
        ) + 2,
    }));

    // Style thead rows as bold
    for (let row = 0; row < headerRowCount; row++) {
      for (let col = 0; col < rows[row].length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        if (ws[cellRef]) {
          ws[cellRef].s = {
            alignment: { horizontal: "center" },
            font: { bold: true },
          };
        }
      }
    }

    // Create workbook and export
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}

export function commonapisgsdp(
  formik,
  roleid,
  setDistrictList,
  setMandalList,
  district,
) {
  MasterService.getDistricts().then((res) => {
    if (res.data) {
      // setDistrictnamelist(res.data)
      let options = res.data.map((item, i) => {
        return (
          <option key={i} value={item.id}>
            {" "}
            {item.value}{" "}
          </option>
        );
      });
      setDistrictList(options);
    }
  });

  let params = { district_id: district };
  MasterService.getMandals(params).then((mandalRes) => {
    // setMandalnamelist(mandalRes.data)
    if (mandalRes) {
      let options = mandalRes.data.map((item, i) => (
        <option key={i} value={item.id}>
          {" "}
          {item.value}{" "}
        </option>
      ));
      setMandalList(options);
    }
  });
  if (roleid === "2") {
    formik.setFieldValue("district_id", district);
  }
}

export const startYear = 2022;
export const endYear = 2047;

export function generateYears() {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(`${year}-${(year + 1).toString().slice(-2)}`);
  }
  return years;
}

export const startgrowthYear = 2023;
export const endgrowthYear = 2047;
export function generategrowthYears() {
  {
    const years = [];
    for (let year = startgrowthYear; year <= endgrowthYear; year++) {
      years.push(`${year}-${(year + 1).toString().slice(-2)}`);
    }
    return years;
  }
}

export function generateemployeemapPdf(tableid, filename) {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  doc.autoTable({
    html: tableid,
    theme: "grid",
    tableWidth: 530,
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      if (data.cell.raw) {
        const totalColumns = data.table.columns.length;
        if (data.column.index === totalColumns - 1) {
          data.cell.text = "";
          data.cell.styles.cellPadding = 0;
          data.cell.styles.cellWidth = 0;
          data.cell.styles.minCellHeight = 0;
        }
        if (
          data.section === "head" &&
          data.cell.colSpan > 1 &&
          data.column.index === totalColumns - 1
        ) {
          data.cell.colSpan = 1;
        }
        const select = data.cell.raw.querySelector("select");
        if (select) {
          const selectedText =
            select.options[select.selectedIndex]?.text.trim();
          data.cell.text = selectedText === "--Select--" ? "" : selectedText;
        }
        const img = data.cell.raw.querySelector("img");
        if (img) {
          data.cell.text =
            img.getAttribute("alt") ||
            img.getAttribute("data-value") ||
            "Image";
        }
      }
    },
  });

  doc.save(`${filename}.pdf`);
}

export function exportToempmapExcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;

    const rows = Array.from(table.rows).map((row) =>
      Array.from(row.cells)
        .slice(0, -1)
        .map((cell) => {
          const select = cell.querySelector("select");
          if (select) {
            const selectedText =
              select.options[select.selectedIndex]?.text.trim();
            return selectedText === "--Select--" ? "" : selectedText;
          }

          const icon = cell.querySelector("img, svg, i");
          if (icon && icon.alt) {
            return icon.alt;
          }

          return cell.textContent.trim();
        }),
    );

    const ws = XLSX.utils.aoa_to_sheet(rows); const range = XLSX.utils.decode_range(ws["!ref"]); const columnWidths = [];
    for (let col = 0; col <= range.e.c; col++) {const colLetter = XLSX.utils.encode_col(col);
      const cellWidth = Math.max( ...Object.keys(ws) .filter((cell) => cell.startsWith(colLetter)) .map((cell) => ws[cell] ? (ws[cell].v ? ws[cell].v.toString().length : 0) : 0, ), );
      columnWidths[col] = { wch: cellWidth + 2 }; } ws["!cols"] = columnWidths;

    const headerRow = range.s.r;
    for (let col = 0; col <= range.e.c; col++) {
      const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c: col })]; if (cell) { cell.s = { alignment: { horizontal: "center" }, font: { bold: true } }; }
    }
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`); } catch (error) { console.error("Error exporting to Excel:", error); } }

export const datetime = (setcurrentdate, setcurrenttime) => {
  const currentDate = new Date().toLocaleDateString("en-GB");
  setcurrentdate(currentDate);
  const now = new Date();
  const options = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };
  const formattedTime = now.toLocaleTimeString("en-IN", options);
  setcurrenttime(formattedTime.toUpperCase());
};

export function createSelectField(
  name,
  optionsList,
  value,
  setFieldValue,
  additionalOnChange = null,
  disabled = null,
  menuPortalTarget = null,
  styles = null,
) {
  return (
    <Select
      className="w-100"
      isClearable={true}
      isSearchable={true}
      name={name}
      required={true}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.value}
      options={optionsList}
      value={optionsList?.find((option) => option.id === value) || ""}
      onChange={(option) => {
        setFieldValue(name, option ? option.id : "");
        if (additionalOnChange) additionalOnChange(option);
      }}
      isDisabled={disabled}
      {...(menuPortalTarget ? { menuPortalTarget } : {})}
      {...(styles ? { styles } : {})}
    />
  );
}
export function isValidIndianMobileNumber(mobile) {
  if (!mobile) {
    return true;
  }
  const mobileRegex = /^[6-9]\d{9}$/;
  return mobileRegex.test(mobile);
}

export const restrictToPasteOnlyMobileNumber = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const mobileRegex = /^[6-9]\d{9}$/;

    if (mobileRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyempid = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const mobileRegex = /^\d{1,8}$/;

    if (mobileRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyempname = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const nonDigitRegex = /^\D+$/;

    if (nonDigitRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyemail = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const emailRegex =
      /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const getCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  if (month >= 4) {
    // From April to December
    return `${year}-${(year + 1).toString().slice(-2)}`;
  } else {
    // From January to March
    return `${year - 1}-${year.toString().slice(-2)}`;
  }
};

export const convertFormattedToPlainNumber = (formattedValue) => {
  if (!formattedValue) return "";

  const plain = formattedValue.toString().replace(/,/g, "");

  // Check if the result is a valid number (allowing negatives and decimals)
  const isValid = /^-?\d*(\.\d+)?$/.test(plain);

  return isValid ? plain : "";
};

// export const denomallowNumberswithMaxLengthtypeOnly = (e, maxLength, type, limit) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;
//   const fieldMaxlength = maxLength ?? 9;

//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
//   if (allowedKeys.includes(key)) {
//     return;
//   }

//   // Block any non-digit and non-dot keys
//   if (!/[\d.]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);

//   if (type === "numeric") {
//     // Prevent '.' as the first character
//     if (key === '.' && (value === '' || selectionStart === 0)) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only up to `limit` decimal places
//     const numericRegex = new RegExp(`^\\d{0,${fieldMaxlength}}(\\.\\d{0,${limit}})?$`);
//     if (!numericRegex.test(newValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^\\d{0,${fieldMaxlength}}$`);
//     if (!intRegex.test(newValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const denomallowNumberswithMaxLengthtypeOnly = (
  e,
  maxLength,
  type,
  limit,
) => {
  let value = e.target.value;
  const fieldMaxlength = maxLength ?? 9;

  if (type === "numeric") {
    // Remove invalid characters except digit and dot
    value = value.replace(/[^0-9.]/g, "");

    // Allow only one dot
    value = value.replace(/(\..*)\./g, "$1");

    // Prevent dot as the first character
    if (value.startsWith(".")) {
      value = value.replace(".", ""); // remove starting dot
    }

    // Split decimal
    const parts = value.split(".");

    let intPart = parts[0] ?? "";
    let decPart = parts[1] ?? "";

    // Limit integer part length
    intPart = intPart.slice(0, fieldMaxlength);

    // Limit decimal part length
    if (parts.length > 1) {
      decPart = decPart.slice(0, limit);
      value = intPart + "." + decPart;
    } else {
      value = intPart;
    }
  }

  if (type === "int") {
    // Digits only
    value = value.replace(/[^0-9]/g, "");

    // Limit max length
    value = value.slice(0, fieldMaxlength);
  }

  // Set final value
  e.target.value = value;
};

// export const allowNumberswithMaxLengthtypeOnly = (e, maxLength, type, limit, isAllowedNegative) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;
//   const fieldMaxlength = maxLength ?? 9;
//   console.log("isAllowedNegative", isAllowedNegative);
//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
//   if (allowedKeys.includes(key)) return;

//   // Allow digits, dot, and minus if applicable
//   if (!/[\d.-]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);

//   // Check for minus sign
//   if (key === '-') {
//     // Only allow minus if negative numbers are allowed, and only at the beginning
//     if (isAllowedNegative !== "-1" || selectionStart !== 0 || value.includes('-')) {
//       e.preventDefault();
//       return;
//     }
//     return; // Allow valid '-'
//   }

//   if (type === "numeric") {
//     // Prevent '.' as the first character or after '-'
//     if (key === '.' && (value === '' || selectionStart === 0 || (isAllowedNegative && selectionStart === 1 && value.startsWith('-')))) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     const numericRegex = new RegExp(
//       `^-?\\d{0,${fieldMaxlength}}(\\.\\d{0,${limit}})?$`
//     );
//     if (!numericRegex.test(newValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^-?\\d{0,${fieldMaxlength}}$`);
//     if (!intRegex.test(newValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const allowNumberswithMaxLengthtypeOnly = (
  e,
  maxLength,
  type,
  limit,
  isAllowedNegative,
  // setFieldValue,
  // fieldName
) => {
  let value = e.target.value;
  const fieldMaxlength = maxLength ?? 9;

  value = value.replace(/,/g, ""); if (isAllowedNegative !== "-1") { value = value.replace(/-/g, ""); } else { value = value.replace(/(?!^)-/g, "").replace(/--+/g, "-"); }

  if (type === "numeric") { value = value.replace(/[^0-9.-]/g, ""); value = value.replace(/(?!^)-/g, ""); value = value.replace(/(\..*)\./g, ""); if (value.startsWith(".")) { value = value.replace(".", ""); }

    let [intPart, decPart = ""] = value.split("."); intPart = intPart.replace("-", "").slice(0, fieldMaxlength); decPart = decPart.slice(0, limit); value = (value.startsWith("-") ? "-" : "") + intPart + (value.includes(".") ? "." + decPart : ""); }

  if (type === "int") {
    value = value.replace(/[^0-9-]/g, "");

    if (value.startsWith("-")) {
      value =
        "-" +
        value
          .slice(1)
          .replace(/[^0-9]/g, "")
          .slice(0, fieldMaxlength);
    } else {
      value = value.replace(/[^0-9]/g, "").slice(0, fieldMaxlength);
    }
  }

  // UI update
  e.target.value = value;

  // Formik update
  // setFieldValue(fieldName, value);
};

// export const allowNumberswithMaxLengthcatidtypeOnly = (e, maxLength, type, limit, isAllowedNegative) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;

//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
//   if (allowedKeys.includes(key)) return;

//   // Allow digits, dot, and minus if applicable
//   if (!/[\d.-]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);
//   const cleanNewValue = newValue.replace(/,/g, "");

//   // Handle negative sign
//   if (key === '-') {
//     if (isAllowedNegative !== "-1" || selectionStart !== 0 || value.includes('-')) {
//       e.preventDefault();
//       return;
//     }
//     return; // allow valid '-'
//   }

//   if (type === "numeric") {
//     // Prevent '.' at beginning or right after '-'
//     if (key === '.' && (value === '' || selectionStart === 0 || (isAllowedNegative && value.startsWith('-') && selectionStart === 1))) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     // Regex for numeric with optional negative and decimal limit
//     const numericRegex = new RegExp(`^-?\\d{0,${maxLength}}(\\.\\d{0,${limit}})?$`);
//     if (!numericRegex.test(cleanNewValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^-?\\d{0,${maxLength}}$`);
//     if (!intRegex.test(cleanNewValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const allowNumberswithMaxLengthcatidtypeOnly = (
  e,
  maxLength,
  type,
  limit,
  isAllowedNegative,
) => {
  let value = e.target.value;

  // Remove commas
  value = value.replace(/,/g, "");

  // Negative handling
  if (isAllowedNegative !== "-1") { value = value.replace(/-/g, ""); } else {
    value = value.replace(/(?!^)-/g, "").replace(/--+/g, "-"); }

  if (type === "numeric") { value = value.replace(/[^0-9.-]/g, ""); value = value.replace(/(?!^)-/g, ""); value = value.replace(/(\..*)\./g, "");

    if (value.startsWith(".")) { value = value.replace(".", ""); }
    let [intPart, decPart = ""] = value.split("."); intPart = intPart.replace("-", "").slice(0, maxLength); decPart = decPart.slice(0, limit);

    value = (value.startsWith("-") ? "-" : "") + intPart + (value.includes(".") ? "." + decPart : ""); }

  if (type === "int") {
    value = value.replace(/[^0-9-]/g, "");

    if (value.startsWith("-")) {
      value =
        "-" +
        value
          .slice(1)
          .replace(/[^0-9]/g, "")
          .slice(0, maxLength);
    } else {
      value = value.replace(/[^0-9]/g, "").slice(0, maxLength);
    }
  }

  e.target.value = value;
};

// export const formatNumberIndianWithDecimal = (value) => {
//   if (!value) return "";

//   const numStr = value.toString().replace(/,/g, "");
//   if (isNaN(numStr)) return value;

//   const isNegative = numStr.startsWith("-");
//   const absoluteStr = isNegative ? numStr.slice(1) : numStr;

//   const [integerPart, decimalPart] = absoluteStr.split(".");

//   const n = integerPart.length;

//   let formattedInt;
//   if (n <= 3) {
//     formattedInt = integerPart;
//   } else {
//     let result = integerPart.slice(n - 3);
//     let start = n - 3;

//     while (start > 0) {
//       const end = start;
//       start = Math.max(0, start - 2);
//       result = integerPart.slice(start, end) + "," + result;
//     }
//     formattedInt = result;
//   }

//   const formatted = decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
//   return isNegative ? `-${formatted}` : formatted;
// };

export const formatNumberIndianWithDecimal = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numStr = value.toString().replace(/,/g, "");
  if (isNaN(numStr)) return value;

  const isNegative = numStr.startsWith("-");
  const absoluteStr = isNegative ? numStr.slice(1) : numStr;

  const [integerPart, decimalPart] = absoluteStr.split(".");
  const n = integerPart.length;

  let formattedInt;
  if (n <= 3) {
    formattedInt = integerPart;
  } else {
    let result = integerPart.slice(n - 3);
    let start = n - 3;

    while (start > 0) {
      const end = start;
      start = Math.max(0, start - 2);
      result = integerPart.slice(start, end) + "," + result;
    }
    formattedInt = result;
  }

  const formatted =
    decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;

  return isNegative ? `-${formatted}` : formatted;
};

export function commonSelectProps({
  name,
  options,
  value,
  optionValueKey = "dept_id",
  optionLabelKey = "dept_name",
  isDisabled = false,
  formik,
  extraOnChange = () => {},
}) {
  return {
    className: "w-100",
    isClearable: true,
    isSearchable: true,
    name: name,
    options: options,
    menuPortalTarget: document.body,
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 1000 }),

      singleValue: (base) => ({
        ...base,
        fontWeight: "bold",
      }),

      input: (base) => ({
        ...base,
        fontWeight: "bold",
      }),
    },

    getOptionValue: (option) => option[optionValueKey],
    getOptionLabel: (option) => option[optionLabelKey],

    value: options?.find((option) => option[optionValueKey] === value) || "",

    isDisabled: isDisabled,

    onChange: (option) => {
      const selectedValue = option ? option[optionValueKey] : "";
      formik.setFieldValue(name, selectedValue);

      // Call extra function if needed
      extraOnChange(option);

      // Common functions if you need
      // emptyData ? etc.
    },
  };
}

export function exporKPIExcel(tableId, fileName) {
  const table = document.getElementById(tableId); if (!table) { console.error(`Table with ID ${tableId} not found!`); return; }

  try {
    const sheetName = fileName.length > 31 ? fileName.substring(0, 31) : fileName; const rows = []; const merges = []; const occupied = {}; const maxTextLengths = []; const tableRows = Array.from(table.rows); tableRows.forEach((row, rowIndex) => { const rowData = []; let colIndex = 0; while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }

      Array.from(row.cells).forEach((cell) => {
        const colspan = parseInt(cell.getAttribute("colspan")) || 1; const rowspan = parseInt(cell.getAttribute("rowspan")) || 1; let cellValue = cell.textContent.trim(); const img = cell.querySelector("img");
        if (img) { cellValue = img.getAttribute("alt")?.trim() || img.getAttribute("data-value")?.trim() || "Yes"; }

        const isHeader = row.parentElement.tagName === "THEAD"; let horizontalAlign = isHeader ? "center" : "left"; if (row.textContent.includes("Report On")) { horizontalAlign = "right"; } const alignment = { horizontal: horizontalAlign, vertical: "center", wrapText: true, };
        const cellStyle = { alignment, font: { bold: isHeader, color: { rgb: "000000" } }, }; rowData[colIndex] = { v: cellValue, s: cellStyle }; if (colspan === 1) { const estimatedWidth = cellValue.length <= 4 ? cellValue.length + 4 : Math.ceil(cellValue.length * 1.2); maxTextLengths[colIndex] = Math.max( maxTextLengths[colIndex] || 0, estimatedWidth, ); }

        if (colspan > 1 || rowspan > 1) { merges.push({ s: { r: rowIndex, c: colIndex }, e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, }); for (let r = 0; r < rowspan; r++) { for (let c = 0; c < colspan; c++) { if (r !== 0 || c !== 0) { occupied[`${rowIndex + r},${colIndex + c}`] = true; } } } }

        colIndex += colspan; while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; } }); rows.push(rowData);
    }); const ws = XLSX.utils.aoa_to_sheet(rows); ws["!merges"] = merges; ws["!cols"] = maxTextLengths.map((wch) => ({ wch })); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`); } catch (error) { console.error("Error exporting to Excel:", error); } }

export function generateindPdf(tableid, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  // ✅ Hide sort arrows temporarily
  const sortButtons = document.querySelectorAll(`#${tableid} thead button`);
  const arrowSymbols = [];
  sortButtons.forEach((btn, i) => {
    arrowSymbols[i] = btn.innerHTML; // store arrows
    btn.innerHTML = ""; // remove arrows
  });

  let format = "a4";
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  // ✅ Make sure we prepend '#' here
  doc.autoTable({ html: `#${tableid}`, theme: "grid", styles: { fontSize: 9 }, headStyles: { halign: "center" }, columnStyles: { 0: { cellWidth: "wrap" } },
    didParseCell: function (data) { const rawText = data.cell.text?.join(" ")?.trim(); if (rawText?.startsWith("Report On")) { data.cell.styles.halign = "right"; } if (data.cell.raw && data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; } }, }); doc.save(`${filename}.pdf`);

  // ✅ Restore arrows back to UI
  sortButtons.forEach((btn, i) => {
    btn.innerHTML = arrowSymbols[i];
  });

  exportHeaders.forEach((el) => {
    el.style.display = "none";
  });
}

export const getReadableTimeStamp = () => {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = now.toLocaleString("en-US", { month: "short" });
  const year = now.getFullYear();

  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year}_${hours}-${minutes}-${ampm}`;
};

export async function generatedashPdf(
  tableid,
  filename,
  columnsCount,
  chartid,
  titleText,
) {
  let format = "a4"; // default
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ✅ Title at top center
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(titleText, pageWidth / 2, 15, { align: "center" });

  // ✅ Clone table
  const originalTable = document.getElementById(tableid);
  const clonedTable = originalTable.cloneNode(true);

  // Show only-export rows
  clonedTable.querySelectorAll(".only-export").forEach((el) => {
    el.style.display = "table-row";
  });

  // Remove sort buttons
  clonedTable.querySelectorAll("thead button").forEach((btn) => btn.remove());

  // ✅ Chart export
  const chartElement = document.getElementById(chartid);
  if (chartElement) {
    try {
      const imgData = await domtoimage.toPng(chartElement, {
        quality: 1,
        bgcolor: "#ffffff",
      });

      if (imgData.startsWith("data:image")) {
        const imgProps = doc.getImageProperties(imgData);

        // Half page width
        const chartWidth = pageWidth / 2 - 20;
        let chartHeight = (imgProps.height * chartWidth) / imgProps.width;

        // Cap chart height so it doesn’t exceed page
        if (chartHeight > pageHeight - 40) {
          chartHeight = pageHeight - 40;
        }

        const startY = 25; // same Y for chart + table

        // Draw chart (left half)
        doc.addImage(imgData, "PNG", 10, startY, chartWidth, chartHeight);

        // Draw table (right half)
        doc.autoTable({
          html: clonedTable,
          theme: "grid",
          styles: { fontSize: 8 },
          headStyles: { halign: "center" },
          columnStyles: { 0: { cellWidth: "wrap" } },
          startY: startY,
          margin: { left: pageWidth / 2 },
          tableWidth: pageWidth / 2 - 20,
          pageBreak: "avoid", // keep table on same page
        });
      }
    } catch (err) {
      console.error("dom-to-image failed:", err);
    }
  }

  // ✅ Save PDF
  doc.save(`${filename}_${getReadableTimeStamp()}.pdf`);
}

export function exportTodashExcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sortButtons = table.querySelectorAll("thead button");
    const arrowSymbols = [];
    sortButtons.forEach((btn, i) => {
      arrowSymbols[i] = btn.innerHTML;
      btn.innerHTML = "";
    });

    // ✅ Timestamp
    const timeStamp = getReadableTimeStamp();

    // Sheet name max 31 chars (Excel limit)
    const sheetNameBase = `${fileName}_${timeStamp}`;
    const sheetName =
      sheetNameBase.length > 31
        ? sheetNameBase.substring(0, 31)
        : sheetNameBase;

    const rows = [];
    const merges = [];
    const occupied = {};
    const maxTextLengths = [];

    const tableRows = Array.from(table.rows);

    tableRows.forEach((row, rowIndex) => {
      const rowData = [];
      let colIndex = 0;
      while (occupied[`${rowIndex},${colIndex}`]) colIndex++;

      Array.from(row.cells).forEach((cell) => {
        const colspan = parseInt(cell.getAttribute("colspan")) || 1;
        const rowspan = parseInt(cell.getAttribute("rowspan")) || 1;
        // const cellValue = cell.textContent.trim();
        const isHeader = row.parentElement.tagName === "THEAD";

        // Detect numeric values
        let cellValue = cell.textContent.trim();
        const numericValue = Number(cellValue.replace(/,/g, ""));
        const isNumber = !isNaN(numericValue) && cellValue !== "";

        let horizontalAlign = isHeader ? "center" : "left";
        if (row.textContent.includes("Report On")) {
          horizontalAlign = "right";
        }

        const alignment = {
          horizontal: horizontalAlign,
          vertical: "center",
          wrapText: true,
        };
        const cellStyle = {
          alignment,
          font: { bold: isHeader, color: { rgb: "000000" } },
        };

        // rowData[colIndex] = { v: cellValue, s: cellStyle };
        rowData[colIndex] = {
          v: isNumber ? numericValue : cellValue,
          t: isNumber ? "n" : "s",
          s: cellStyle,
        };

        if (colspan === 1) { const estimatedWidth = cellValue.length <= 4 ? cellValue.length + 4 : Math.ceil(cellValue.length * 1.2); maxTextLengths[colIndex] = Math.max( maxTextLengths[colIndex] || 0, estimatedWidth, ); }

        if (colspan > 1 || rowspan > 1) { merges.push({ s: { r: rowIndex, c: colIndex }, e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, }); for (let r = 0; r < rowspan; r++) { for (let c = 0; c < colspan; c++) { if (r !== 0 || c !== 0) { occupied[`${rowIndex + r},${colIndex + c}`] = true; } } } } colIndex += colspan;
        while (occupied[`${rowIndex},${colIndex}`]) colIndex++;
      });

      rows.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!merges"] = merges;
    ws["!cols"] = maxTextLengths.map((wch) => ({ wch }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // ✅ Final Excel filename with timestamp
    XLSX.writeFile(wb, `${fileName}_${timeStamp}.xlsx`);

    // Restore sort icons
    sortButtons.forEach((btn, i) => {
      btn.innerHTML = arrowSymbols[i];
    });
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}
export const isFY2025OrLater = (fy) => {
  const startYear = parseInt(fy.split("-")[0], 10);
  return startYear >= 2025;
};

export function allowOnlyNumbersandDecimal(e) {
  const char = e.key;
  if (!/[0-9.]/.test(char)) {
    e.preventDefault();
  }
  if (char === "." && e.target.value.includes(".")) {
    e.preventDefault();
  }
}

export function multiGeneratePdf(containerId, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => (el.style.display = "table-row"));

  let format = "a4";
  if (columnsCount > 15) format = "a0";
  else if (columnsCount > 10) format = "a2";
  else format = "a3";

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  const container = document.getElementById(containerId);
  if (!container) {
    console.error("Container not found");
    return;
  }

  const tables = container.querySelectorAll("table");

  tables.forEach((table, index) => {
    doc.autoTable({
      html: table,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: { halign: "center" },
    });

    // Add space between tables
    if (index < tables.length - 1) {
      doc.addPage();
    }
  });

  doc.save(`${filename}.pdf`);

  exportHeaders.forEach((el) => (el.style.display = "none"));
}

export function mutliExportToExcel(containerId, fileName) {
  const container = document.getElementById(containerId);

  if (!container) {
    console.error(`Container ${containerId} not found!`);
    return;
  }

  const tables = container.querySelectorAll("table");

  if (tables.length === 0) {
    console.error("No tables found inside container!");
    return;
  }

  const wb = XLSX.utils.book_new();

  tables.forEach((table, index) => {
    const sheetName =
      tables.length > 1 ? `Table_${index + 1}` : fileName.substring(0, 31);

    const ws = XLSX.utils.table_to_sheet(table);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  XLSX.writeFile(wb, `${fileName}.xlsx`);
}


export const maskMobile = (phone) => {
  if (!phone) return "";
  const visible = phone.slice(-4);
  const masked = phone.slice(0, -4).replace(/./g, "*");

  return masked + visible;
};

export const maskEmail = (email) => {
  if (!email) return "";

  const [name, domain] = email.split("@");

  if (name.length <= 4) {
    return `${"*".repeat(name.length)}@${domain}`;
  }

  const visiblePart = name.slice(-4);
  const maskedPart = "*".repeat(name.length - 4);

  return `${maskedPart}${visiblePart}@${domain}`;
};